// extracted by mini-css-extract-plugin
export default {"main":"Input_main__DA-5l","container":"Input_container__Te6oV","reset":"Input_reset__fcMcS"};